<template>
    <div class="visibility">
        <div class="cards">
            <div class="card">
                <Icon class="cardIcon"
                    icon="magic_button"
                    size="l"/>
                <Heading :h="4">
                    {{ content.featured }}
                </Heading>
                <p class="description">
                    {{ content.feautredDescription }}
                </p>
            </div>
            <div class="card">
                <Icon class="cardIcon"
                    icon="person_add_alt"
                    size="l"/>
                <Heading :h="4">
                    {{ content.following }}
                </Heading>
                <p class="description">
                    {{ content.followingDescription }}
                </p>
            </div>
            <div class="card">
                <Icon class="cardIcon"
                    icon="stream"
                    size="l"/>
                <Heading :h="4">
                    {{ content.fresh }}
                </Heading>
                <p class="description">
                    {{ content.freshDescription }}
                </p>
            </div>
        </div>
        <div class="text">
            <Heading :h="2" size="xxl">
                {{ content.alwaysVisible }}
            </Heading>
            <p class="sub">
                {{ content.alwaysVisibleDescription }}
            </p>
            <p class="paragraph">
                {{ content.alwaysVisibleSubdescription }}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Visibility',
        props: {
            content: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .visibility {
        display: flex;
    }

    .text {
        width: 32rem;
    }

    .h4 {
        margin: 1.5rem 0 0.5rem 0;
    }

    .description {
        margin: 0;
        color: var(--color-grey-600);
        font-family: $font-secondary;
    }

    .h2 {
        margin: 0.5rem 0 1.5rem 0;
    }

    .sub {
        font-family: $font-secondary;
        font-size: 1.5rem;
    }

    .paragraph {
        margin: 4rem 0 0 4rem;
    }

    .card {
        max-width: 24rem;
        width: 100%;
        padding: 1.5rem 2rem;
        background: var(--color-white-40);
        border-radius: 2rem;
        margin-bottom: 1.5rem;

        &:nth-child(2) {
            margin-left: 4rem;
        }

        &:nth-child(3) {
            margin-left: 8rem;
        }
    }

    .cardIcon {
        color: var(--color-primary-500) !important;
        cursor: default !important;
    }

    @media all and (max-width: 960px) {
        .visibility {
            flex-direction: column-reverse;
        }

        .text {
            margin-bottom: 4rem;
            margin-left: 3rem;
            max-width: 40rem;
            width: calc(100% - 4rem);
        }

        .cards {
            display: flex;
        }

        .card {
            margin-bottom: 0;
            padding: 1.5rem;

            &:nth-child(2), &:nth-child(3) {
                margin-left: 0.5rem;
            }
        }

        .description {
            font-size: 1rem;
        }
    }

    @media all and (max-width: 560px) {
        .cards {
            flex-wrap: wrap;
        }

        .card {
            margin-bottom: 1rem;
            min-width: 14rem;
            flex: 1;

            &:nth-child(2) {
                margin-left: 4rem;
            }

            &:nth-child(3) {
                margin-left: 8rem;
            }
        }
    }
</style>